import { useLingui } from '@lingui/react/macro';
import { useAuth } from 'modules/auth/ui/hooks/use-auth';
import { useAuthGuard } from 'modules/auth/ui/hooks/use-auth-guard';
import { Pages } from 'modules/navigation/domain/enums/pages';
import React from 'react';
import { Navigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useIsAdmin } from 'shared/hooks/use-is-admin';

type SecureRouteProps = {
  children: JSX.Element;
  tournamentRequired?: boolean;
  adminOnly?: boolean;
};

const SecureRoute = React.memo((props: SecureRouteProps) => {
  useAuthGuard();
  const { tournamentRequired = true, adminOnly = false, children } = props;

  const { isAuthed, isChecked, isChecking, userTournamentId, hasTournaments } = useAuth();

  const isAdmin = useIsAdmin();
  const { t } = useLingui();

  if (!isChecked || isChecking) {
    return null;
  }

  if (!isAuthed) {
    return <Navigate to={Pages.SIGN_IN} />;
  }

  if (tournamentRequired && !hasTournaments) {
    toast.warning(t`Необходимо заполнить профиль и сохранить организацию`);
    return <Navigate to={Pages.SETTINGS.INDEX} />;
  }

  if (adminOnly && !isAdmin) {
    return <Navigate to={Pages.INDEX} />;
  }

  if (tournamentRequired && !userTournamentId) {
    return <Navigate to={Pages.SELECT_TOURNAMENT} />;
  }

  return children;
});

export default SecureRoute;
